module.exports = __webpack_public_path__ + "static/media/prognostics.401266c6.png";